module.exports = __webpack_public_path__ + "img/Maskgroup.7c45a0cd.png";